import { Component, inject, Input } from '@angular/core';
import { BuildingBadgeDto } from '@artemis-software/wr-api';
import { Router } from '@angular/router';
import { Tracked } from '@/utils/signals/tracked';

@Component({
  standalone: false,
  selector: 'wr-building-entity-badge',
  templateUrl: './building-entity-badge.component.html',
  styleUrls: ['./building-entity-badge.component.scss'],
})
export class BuildingEntityBadgeComponent {
  private readonly router = inject(Router);

  @Input()
  @Tracked()
  building?: BuildingBadgeDto;

  navigate(event: MouseEvent): void {
    event.stopPropagation();
    this.router.navigate(['building', this.building!.id]);
  }
}
